import { FC } from 'react';
import { useFragment } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import Tabber from 'components/Tabber';
import PackageEditMain from 'components/PackageEditMain';
import MediaEditor from 'components/MediaEditor';
import PackageEditTransport from 'components/PackageEditTransport';
import PackageEditAccommodation from 'components/PackageEditAccommodation';
import SeoTab from 'components/SeoTab';
import EntityHistory from 'components/EntityHistory';
import PackageEditDates from 'components/PackageEditDates';

import { PackageEditTabs_package$key } from '__generated__/PackageEditTabs_package.graphql';
import { PackageEditTabs_data$key } from '__generated__/PackageEditTabs_data.graphql';

type Props = {
  package: PackageEditTabs_package$key;
  data: PackageEditTabs_data$key;
};

const PackageEditTabs: FC<Props> = props => {
  const pack = useFragment(
    graphql`
      fragment PackageEditTabs_package on Package {
        allDates: tripDates(first: 2147483647) {
          pageInfo {
            total
          }
        }

        media(first: 2147483647) {
          pageInfo {
            total
          }
        }

        ...MediaEditor_mediable
        ...PackageEditMain_package
        ...PackageEditTransport_package
        ...PackageEditAccommodation_package
        ...PackageEditDates_package
        ...SeoTab_seoable
        ...EntityHistory_entity
      }
    `,
    props.package
  );

  const data = useFragment(
    graphql`
      fragment PackageEditTabs_data on Query {
        ...PackageEditMain_data
        ...PackageEditTransport_data
        ...PackageEditAccommodation_data
        ...PackageEditDates_data
      }
    `,
    props.data
  );

  return (
    <Tabber
      variant="scrollable"
      scrollButtons="auto"
      tabs={[
        {
          title: 'Apie',
          hash: 'main',
          component: <PackageEditMain package={pack} data={data} />,
        },
        {
          title: `Nuotraukos [${pack.media?.pageInfo.total ?? 0}]`,
          hash: 'media',
          component: <MediaEditor mediable={pack} />,
        },
        {
          title: `Kelionės datos [${pack.allDates?.pageInfo.total ?? 0}]`,
          hash: 'dates',
          component: <PackageEditDates package={pack} data={data} />,
        },
        {
          title: 'Transportas',
          hash: 'transport',
          component: <PackageEditTransport package={pack} data={data} />,
        },
        {
          title: `Apgyvendinimas`,
          hash: 'accommodation',
          component: <PackageEditAccommodation package={pack} data={data} />,
        },
        {
          title: 'Seo',
          hash: 'seo',
          component: (
            <SeoTab
              seoable={pack}
              type="PACKAGE"
              urlPrefix="/kelione/"
              seoableUrlPrefix="/packages/"
            />
          ),
        },
        {
          title: 'Istorija',
          hash: 'history',
          component: <EntityHistory entity={pack} />,
        },
      ]}
    />
  );
};

export default PackageEditTabs;
